import { useMemo } from "react";

import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";

const MyTeamManageShiftTable = ({ isLoading = false, dataSource = [] }) => {
  const columns = useMemo(() => {
    return [
      {
        title: <div className="text-table">Employee</div>,
        dataIndex: "employee",
        key: "employee",
        width: 50,
        fixed: "left",
      },
    ];
  }, []);

  const scroll = useMemo(() => {
    return {
      x: 1300,
    };
  }, []);

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      scroll={scroll}
    />
  );
};

export default MyTeamManageShiftTable;
